import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M4.508 14.032v-1.27h1.27a.635.635 0 1 0 0-1.27h-1.27v-1.27a.635.635 0 1 0-1.27 0v1.27h-1.27a.635.635 0 0 0 0 1.27h1.27v1.27a.635.635 0 0 0 1.27 0m10.159-6.875V3.873a2.54 2.54 0 0 0-2.54-2.54H8.843c-.505 0-.99.201-1.347.558L2.601 6.787a2.16 2.16 0 0 0-.634 1.53.635.635 0 0 0 1.27 0 .9.9 0 0 1 .262-.633L8.394 2.79a.64.64 0 0 1 .45-.186h3.283c.701 0 1.27.569 1.27 1.27v3.284c0 .168-.067.33-.186.449L8.316 12.5a.9.9 0 0 1-.634.263.635.635 0 0 0 0 1.27c.554 0 1.109-.212 1.53-.634l4.897-4.895c.357-.358.558-.842.558-1.347m-2.223-2.332a1.27 1.27 0 1 0-2.54 0 1.27 1.27 0 0 0 2.54 0"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })